import { render, staticRenderFns } from "./LayoutConfiguracao.vue?vue&type=template&id=8144b0ae&scoped=true"
import script from "./LayoutConfiguracao.vue?vue&type=script&setup=true&lang=js"
export * from "./LayoutConfiguracao.vue?vue&type=script&setup=true&lang=js"
import style0 from "./LayoutConfiguracao.vue?vue&type=style&index=0&id=8144b0ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8144b0ae",
  null
  
)

export default component.exports